import { ReactComponent as SvgLogo } from '../../../../images/svg/logo-dark.svg'
import { ReactComponent as SvgSplashtop } from '../../../../images/svg/splashtop-text.svg'

const Logo = () => {
  return (
    <div style={{ position: 'relative', height: '35px' }}>
      <SvgLogo style={{ height: '35px', position: 'absolute', top: '0' }} />
      <SvgSplashtop style={{ height: '22px', position: 'absolute', top: '10px', left: '45px' }} />
    </div>
  )
}

export default Logo
